<template>
    <pm-custom-dialog v-if="visible" v-model="visible" :onClose="reset">

        <template v-if="boundRating === 0">



            <div style="background: url(/images/onboarding/faq.jpg) center center / contain no-repeat rgb(255, 255, 255); margin: 0px 0px 20px 0; width: 100%; height: 170px;"></div>

            <div style="margin-bottom: 16px; text-align: center;">
                <h2 style="line-height: 1.2; font-weight: 600; text-shadow: 0.5px 0.5px 0 #000;">{{ $t('review.we_doing') }}</h2>
            </div>

            <p style="line-height: 1.3; font-size: 15px; margin-bottom: 8px; padding: 0 30px;">
                Every day we work hard to make DentiCalc the best dental app ever. Let us know what you think.
            </p>

            <br/>

            <div v-if="!$isIOS()" style="text-align: center; margin-top: 8px; margin-bottom: 16px;">
                <mdi @click.native="thumbDown(1)" style="margin: 0 3px;" size="36">mdiStarOutline</mdi>
                <mdi @click.native="thumbDown(2)" style="margin: 0 3px;" size="36">mdiStarOutline</mdi>
                <mdi @click.native="thumbDown(3)" style="margin: 0 3px;" size="36">mdiStarOutline</mdi>
                <mdi @click.native="thumbDown(4)" style="margin: 0 3px;" size="36">mdiStarOutline</mdi>
                <mdi @click.native="thumbUp" style="margin: 0 3px;" size="36">mdiStarOutline</mdi>
            </div>

            <div v-if="$isIOS()" style="text-align: center; margin-top: 8px; margin-bottom: 16px;">
                <div @click="thumbDown(1)" style="box-shadow: 0 0 8px rgba(0,0,0,.15); display: inline-block; border-radius: 32px; padding: 8px 32px;">
                    <mdi size="32" style="color: #c00;">thumb-down-outline</mdi>
                </div>
                <div @click="thumbUp" style="box-shadow: 0 0 8px rgba(0,0,0,.15); margin-left: 24px; display: inline-block; border-radius: 32px; padding: 8px 32px;">
                    <mdi size="32" style="color: green;">thumb-up-outline</mdi>
                </div>
            </div>

        </template>


        <template v-else-if="!showThankYou && boundRating < 5">
            <div class="rating-header">
                <span v-if="boundRating < 3"  style="font-weight: 600;">{{ $t('review.we_are_sorry') }}</span>
                <span v-if="boundRating === 3 || boundRating === 4"  style="font-weight: 600;">{{ $t('review.help_us_improve') }}</span>
            </div>
            <div v-if="!isReviewed" class="container">
                <div style="text-align: center; padding: 0 16px 24px 16px;">
                    {{ $t('review.sad_title') }}
                </div>

                <v-textarea
                    ref="reviewTextArea"
                    solo
                    box
                    name="input-7-1"
                    placeholder="Please let us know how to improve*"
                    v-model="reviewContent"
                    class="review-content"
                    :rows="3"
                />

                <v-text-field ref="reviewEmail" box id="feedback-email-input" v-model="email" :placeholder="$t('support.email')" />

                <div style="text-align: center; display: flex; width: 100%; justify-content: space-between; align-items: center;">
                    <u v-if="!isForced || boundRating > 2" style="color: #aaa; display: inline-block; margin-left: 16px;" @click="skipReviewWithSend">
                        {{ $t('review.not_now') }}
                    </u>
                    <br/>
                    <v-btn
                        large
                        round
                        color="primary"
                        @click="submitReview(true)"
                        style="margin-right: 16px;"
                    >
                        {{ $t('review.send') }}
                    </v-btn>
                </div>
            </div>
        </template>


        <template v-else-if="!showThankYou">

            <div style="background: url(/images/onboarding/ratings.jpg) center center / contain no-repeat rgb(255, 255, 255); margin: 0px 0px 20px 0; width: 100%; height: 170px;"></div>

            <div style="margin-bottom: 16px; text-align: center;">
                <h2 style="line-height: 1.2; font-weight: 600; text-shadow: 0.5px 0.5px 0 #000;">{{ $t('review.thank_you_so_much') }}</h2>
            </div>

            <p style="line-height: 1.3; font-size: 15px; margin-bottom: 8px; padding: 0 30px;">


                <span style="background: #fff;">{{ $t('review.our_work') }}</span><br/><br/>
                    <span style="font-weight: 600">{{ $t('review.please_rate_us') }}</span>
                    <span v-if="$isIOS()"> {{ $t('review.on_the') }} App Store</span>
                    <span v-else> {{ $t('review.on') }} Google Play</span>
                    {{ $t('review.share_thoughts') }}
                    <br/>

                    <v-btn
                        style="text-decoration: underline"
                        :outline="boundRating >= showInAppReviewFromRating"
                        large
                        round
                        @click="$emit('close')"
                    >
                        {{ $t('core.btn_close') }}
                    </v-btn>

            </p>


            <!-- <div style="background: url(https://public.app.denticalc.com/images/confetti.jpg); background-size: 100%; background-repeat: no-repeat; background-position: center top; border-radius: 10px;">
                <br/>
                <div class="rating-header">
                    <span style="background: #fff; font-weight: 600; text-shadow: 2px 2px 0 #fff, -2px -2px 0 #fff;">{{ $t('review.thank_you_so_much') }}</span>
                </div>

                <div style="position: relative; text-align: center; padding: 0px 20px 24px 20px;">
                    <span style="background: #fff;">{{ $t('review.our_work') }}</span><br/><br/>
                    <span style="font-weight: 600">{{ $t('review.please_rate_us') }}</span>
                    <span v-if="$isIOS()"> {{ $t('review.on_the') }} App Store</span>
                    <span v-else> {{ $t('review.on') }} Google Play</span>
                    {{ $t('review.share_thoughts') }}
                    <br/>

                    <img style="width: 60px; position: absolute; left: -10px; top: 60px; transform: rotate(10deg);" src="data:image/png;base64,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" />

                    <v-btn
                        style="text-decoration: underline"
                        :outline="boundRating >= showInAppReviewFromRating"
                        large
                        round
                        @click="$emit('close')"
                    >
                        {{ $t('core.btn_close') }}
                    </v-btn>
                </div>
            </div> -->
        </template>


        <template v-else-if="showThankYou">
            <div class="rating-header">
                <span style="font-weight: 600;" v-html="$t('review.thank_you')" />
            </div>
            <br/>
            {{ $t('review.improve') }}
            <u style="color: #aaa; display: inline-block; line-height: 32px; margin-top: 16px; margin-bottom: 32px;" @click="$emit('close')">
                {{ $t('core.btn_close') }}
            </u>
        </template>

    </pm-custom-dialog>

</template>

<style>
    .rating-header {
        min-width: 280px; font-weight: 600; font-size: 20px; margin-bottom: 0px; border-bottom: 0px solid #eee; text-align: center; width: 100%; padding: 24px 0 0px 0;
    }
</style>

<script>
import { commands, semaphore } from "@/utils/flutter/flutter2-semaphore";
import { getFirstRunTimeStamp } from "@/utils/user/first-run-timestamp";
import { getUserDataAsString } from "@/utils/user/user-data";
import PmCustomDialog from "./base-dialog.vue";
import { invokeFlutterService } from '@/utils/flutter/flutter-service';

export default {
    components: {
        PmCustomDialog
    },
    props: {
        isForced: {
            type: Boolean,
            default: true,
        },
    },
    data: () => ({
        visible: false,
        boundRating: 0,
        reviewContent: '',
        isReviewed: false,
        showInAppReviewFromRating: 4,
        showThankYou: false,
        email: '',
    }),
    computed: {
        textVersion() {
            return this.getRandomInt(2);
        },
    },
    watch: {
        email() {
            localStorage.setItem("userEmailSend", this.email);
        },
    },

    created() {
        this.email = localStorage.getItem("userEmailSend") || "";
    },
    methods: {
        reset() {
            this.visible = false;
            this.boundRating = 0;
        },
        show() {
            this.visible = true;
        },
        getRandomInt(max) {
            return Math.floor(Math.random() * Math.floor(max));
        },
        thumbDown(rating) {
            this.boundRating = rating;
            this.logReviewSubmit();
            this.$nextTick(()=>{
                this.$refs.reviewTextArea.focus();
            });
        },
        thumbUp() {
            this.boundRating = 5;
            this.submitReview(false);
            this.openReview();
            this.logReviewSubmit();
        },
        skipReview() {
            window.Tracker.logEvent({
                event_name: "skip_review",
                event_category: "review",
                event_label: "Review_v2",
            });
            this.$emit('close');
        },
        skipReviewWithSend() {
            this.callSlackWebhook();
            window.Tracker.logEvent({
                event_name: "skip_review",
                event_category: "review",
                event_label: "Review_v2",
            });
            this.$emit('close');
        },
        logReviewSubmit() {
            localStorage.setItem('lastReviewSubmitted', `${Date.now()}`);
        },
        submitReview(close) {
            if (this.boundRating == 1 && this.reviewContent.trim().length === 0) {
                this.$refs.reviewTextArea.focus();
                return;
            }

            if (this.boundRating == 1 && this.email.trim().length === 0) {
                this.$refs.reviewEmail.focus();
                return;
            }

            this.callSlackWebhook();
            if (close) this.showThankYouMessage();
            window.Tracker.logEvent({
                event_name: "submit_review",
                event_category: "review",
                event_label: "Review_v2",
                event_value: this.boundRating,
            });
            if (close) this.showThankYou = true;
        },
        openReview() {
            try {
                window.flutterEventLog.unshift({
                    eventName: "FlutterInAppReviewService.requestReview",
                    data: {},
                });
                invokeFlutterService("FlutterInAppReviewService", "requestReview");
            } catch(error) {

                window.flutterEventLog.unshift({
                    eventName: "Error.review",
                    data: error,
                });

                console.error(e);
                captureException(error);
            }

            try {
                window.Tracker.logEvent({
                    event_name: "store_review",
                    event_category: "review",
                    event_label: "Review_v2",
                    event_value: this.boundRating,
                });

                if ('SemaphoreJavascriptChannel' in window) {
                    window.flutterEventLog.unshift({
                        eventName: "SemaphoreJavascriptChannel.review",
                        data: {},
                    });
                    semaphore({
                        name: commands.review.command,
                        data: {},
                    })
                } else {

                }
                
            } catch(error) {

                window.flutterEventLog.unshift({
                    eventName: "Error.review",
                    data: error,
                });

                console.error(e);
                captureException(error);
            }

            if (this.$isIOS()) {
                
                window.flutterEventLog.unshift({
                    eventName: "AppStore.open",
                    data: {},
                });

                const src = "https://apps.apple.com/us/app/denticalc-the-dental-app/id1537539049?action=write-review";
                // "https://play.google.com/store/apps/details?id=com.denticalc.demo";
                window.location.href = src;
            }
        },
        async callSlackWebhook() {
            try {
                const url = 'https://hooks.slack.com/services/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';
                const body = JSON.stringify({
                    username: 'DentiCalc 4in1 app review',
                    icon_url: 'https://public.app.denticalc.com/images/denti_calc_icon.png',
                    text: `In-app-rating: ${this.boundRating}\n\n${this.reviewContent}\n\n${this.getClientData()}`,
                    channel: "#denticalc-feedback",
                });
                const payload = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body,
                };

                // Send only bad ratings
                if (this.boundRating < 3 || this.reviewContent) await fetch(url, payload);

                this.reviewContent = '';
            } catch(error) {
                console.error(error);
                captureException(error);
            }
        },
        showThankYouMessage() {
            this.isReviewed = true;
        },
        getClientData() {
            try {
                const debug = {
                    app_country: this.$store.state.localSettings.country,
                    app_currency: this.$store.state.currency,
                    app_language: this.$store.state.language,
                    app_package_name: window.packageName,
                    app_version: window.appVersion,
                    email: localStorage.getItem("userEmailSend") || "-",
                    navigator_appVersion: navigator.appVersion,
                    navigator_language: navigator.language,
                    navigator_platform: navigator.platform,
                    navigator_vendor: navigator.vendor,
                    is_pro: window.IAP.hasAccessToComponent('premium'),
                    first_run_ts: getFirstRunTimeStamp(),
                    first_run: new Date(getFirstRunTimeStamp()).toISOString(),
                    manual_review: this.isForced,
                    text_version: this.textVersion === 0 ? 'How is your experience?' : 'How are we doing?',
                };

                const rows = Object.keys(debug).map((key) => ` - ${key}: ${debug[key]}\n`);

                rows.unshift('\n```');
                rows.push('```');

                return rows.join``;
            } catch(error) {
                console.error(error);
                captureException(error);
                return '';
            }
        },
    },
}
</script>

<style>
.review-content {
    resize: none;
}
</style>
